import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAttachment } from 'src/app/model/attachments/iattachment';
import { IApplication } from 'src/app/model/iapplication';
import { ModelUtil } from 'src/app/model/model-util';
import { ISubmitApplication } from 'src/app/model/service/isubmit-application';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {

  constructor(private httpClient: HttpClient) { }

  public generateDocument(input: IApplication): Observable<IAttachment> {
    const application: ISubmitApplication = ModelUtil.toSubmitApplication(input);
    return this.httpClient.post<IAttachment>(environment.baseUrl + '/v1/generateLlegDocument', application);
  }

  public generateFlyleafDocument(dnr: string, ssn: string): Observable<IAttachment> {
    const params = {
      dnr,
      ssn: ModelUtil.formatSsn(ssn),
    };
    return this.httpClient.get<IAttachment>(environment.baseUrl + '/v1/generateFlyleafPdf', { params });
  }
}
